module.exports = __webpack_public_path__ + "img/collections@2x.39aad4e.jpg";